// Google Analytics イベントトラッキング用ヘルパー関数

declare global {
  interface Window {
    gtag?: (
      command: 'event',
      action: string,
      params?: Record<string, unknown>
    ) => void
  }
}

/**
 * Google Analyticsにイベントを送信
 */
export const trackEvent = (
  action: string,
  params?: Record<string, unknown>
) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, params)
  }
}

/**
 * 問い合わせフォーム送信イベント
 */
export const trackContactFormSubmit = (formType: string) => {
  trackEvent('contact_form_submit', {
    form_type: formType,
    page_path: window.location.pathname,
  })
}

/**
 * 問い合わせページ到達イベント
 */
export const trackContactPageView = (formType?: string) => {
  trackEvent('contact_page_view', {
    form_type: formType || 'general',
    page_path: window.location.pathname,
  })
}

/**
 * 問い合わせフォーム開始イベント（入力開始）
 */
export const trackContactFormStart = (formType: string) => {
  trackEvent('contact_form_start', {
    form_type: formType,
    page_path: window.location.pathname,
  })
}
